import type { JSX } from 'react'

export const ActivitySolidIcon = (): JSX.Element => (
  <use href='#activitySolidIcon' height='100%' width='100%' />
)
